import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box } from '../Box/Box';
import * as style from './ClearButton.css';

export const ClearButton = ({
  onClick,
  disabled,
  tabIndex = -1,
  'aria-label': ariaLabel = 'Clear',
}: {
  onClick: () => void;
  disabled?: boolean;
  tabIndex?: number;
  'aria-label'?: string;
}): JSX.Element => {
  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      tabIndex={tabIndex}
      margin="none"
      padding="medium"
      cursor="pointer"
      className={style.ClearButton}
      disabled={disabled}
    >
      <FontAwesomeIcon size="xl" icon={faTimesCircle} />
    </Box>
  );
};
